import { runDemo } from "../shared/demoRunner";
import { createStandardRenderingPipelineScene } from "./scene";

runDemo({ createScene: createStandardRenderingPipelineScene });
